var _rect, _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEthStakeActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "url(#paint0_linear_204_4335)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2289 6.39941L16.1016 6.82133V19.0634L16.2289 19.1873L22.0549 15.8283L16.2289 6.39941Z",
    fill: "#C1CCF8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2261 6.39941L10.3999 15.8283L16.2261 19.1873V13.2454V6.39941Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2285 20.2625L16.1567 20.3479V24.7087L16.2285 24.9131L22.0581 16.9053L16.2285 20.2625Z",
    fill: "#C1CCF8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2261 24.9131V20.2625L10.3999 16.9053L16.2261 24.9131Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2266 19.1871L22.0526 15.8281L16.2266 13.2451V19.1871Z",
    fill: "#8197EE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3999 15.8281L16.2261 19.1871V13.2451L10.3999 15.8281Z",
    fill: "#C1CCF8"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_204_4335",
    x1: 32,
    y1: 32,
    x2: 0,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#556ECC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#627EEA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthStakeActive);
export default __webpack_public_path__ + "static/media/ethStakeActive.73704a84abd6e57d3a567b065dc31dae.svg";
export { ForwardRef as ReactComponent };